module.exports = __webpack_public_path__ + "img/powerBallAd1.c4bb1749.png";